// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"styles_tabContainer__25SOA","tab":"styles_tab__24YTX","active":"styles_active__BvCeb","barIndicator":"styles_barIndicator__1_mKt"};